import React from 'react';
import { FieldConfig } from '../../../playground/common/field-types';
import { renderRateScheduleField } from '../../../playground/endpoints/_shared';
import { ContributionListField } from '../_shared';
import {
  ApvSelectFormValues,
  GENDER_OPTIONS,
  PAYMENT_PERIODICITY_OPTIONS,
  RATE_MODE_OPTIONS,
  REGIME_OPTIONS,
  isFixedRate,
  isSteppedRate,
} from './schema';

const CLIENT = 'Datos del cliente';
const CAPITALS = 'Capitales';
const RATE = 'Tasa de proyección';
const CONTRIBUTIONS = 'Aportes y primas';

export const APV_SELECT_FIELDS: readonly FieldConfig<ApvSelectFormValues>[] = [
  {
    key: 'date_of_birth', label: 'Fecha de nacimiento', kind: 'date', section: CLIENT,
  },
  {
    key: 'gender', label: 'Género', kind: 'select', options: GENDER_OPTIONS, section: CLIENT,
  },
  {
    key: 'net_salary', label: 'Salario líquido (CLP)', kind: 'number', section: CLIENT,
  },
  {
    key: 'regime',
    label: 'Régimen APV',
    kind: 'select',
    options: REGIME_OPTIONS,
    section: CLIENT,
  },
  {
    key: 'death_insured_capital',
    label: 'Capital muerte',
    kind: 'number',
    colClassName: 'col-md-4',
    section: CAPITALS,
  },
  {
    key: 'accidental_death_insured_capital',
    label: 'Capital muerte accidental',
    kind: 'number',
    colClassName: 'col-md-4',
    section: CAPITALS,
  },
  {
    key: 'itp_insured_capital',
    label: 'Capital ITP 2/3',
    kind: 'number',
    colClassName: 'col-md-4',
    section: CAPITALS,
  },
  {
    key: 'rate_mode', label: 'Modo de tasa', kind: 'select', options: RATE_MODE_OPTIONS, section: RATE,
  },
  {
    key: 'projection_rate',
    label: 'Tasa de proyección',
    kind: 'number',
    step: 0.0001,
    visibleWhen: isFixedRate,
    section: RATE,
  },
  {
    key: 'projection_rate_schedule',
    label: 'Tramos de tasa',
    kind: 'custom',
    visibleWhen: isSteppedRate,
    render: renderRateScheduleField,
    section: RATE,
  },
  {
    key: 'agreed_premium',
    label: 'Prima Pactada',
    kind: 'number',
    colClassName: 'col-md-6',
    section: CONTRIBUTIONS,
  },
  {
    key: 'payment_periodicity',
    label: 'Periodicidad de la Prima Pactada',
    kind: 'select',
    options: PAYMENT_PERIODICITY_OPTIONS,
    colClassName: 'col-md-6',
    section: CONTRIBUTIONS,
  },
  {
    key: 'incoming_apv_transfer',
    label: 'Traspaso APV',
    kind: 'number',
    section: CONTRIBUTIONS,
  },
  {
    key: 'contributions',
    label: 'Aportes voluntarios',
    kind: 'custom',
    render: (form) => (
      <ContributionListField
        form={form}
        name="contributions"
        addLabel="+ Agregar aporte"
        emptyLabel="Sin aportes voluntarios."
      />
    ),
    section: CONTRIBUTIONS,
  },
  {
    key: 'agreed_deposits',
    label: 'Depósitos convenidos',
    kind: 'custom',
    render: (form) => (
      <ContributionListField
        form={form}
        name="agreed_deposits"
        addLabel="+ Agregar depósito convenido"
        emptyLabel="Sin depósitos convenidos."
      />
    ),
    section: CONTRIBUTIONS,
  },
];
